// ##############################
// // // NavPills component style
// #############################

import {
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
} from 'assets/jss/material-dashboard-pro-react.jsx';

const navPillsStyle = theme => ({
  root: {
    marginTop   : '20px',
    paddingLeft : '0',
    marginBottom: '0',
    overflow    : 'visible !important',
  },
  flexContainer: {
    [theme.breakpoints.down('xs')]: {
      display : 'flex',
      flexWrap: 'wrap',
    },
  },
  displayNone: {
    display: 'none !important',
  },
  fixed: {
    overflowX: 'visible',
  },
  horizontalDisplay: {
    display: 'block',
  },
  pills: {
    borderBottom: '2px solid #DDDDDD',
    float       : 'left',
    position    : 'relative',
    display     : 'block',
    flex        : '1',
    minWidth    : '100px',
    textAlign   : 'center',
    transition  : 'all .3s',
    padding     : '10px 15px',
    color       : '#555555',
    height      : 'auto',
    opacity     : '1',
    maxWidth    : '100%',
  },
  pillsWithIcons: {
    borderRadius: '4px',
  },
  tabIcon: {
    width  : '30px',
    height : '30px',
    display: 'block',
    margin : '15px 0',
  },
  horizontalPills: {
    width       : '100%',
    float       : 'none !important',
    '& + button': {
      margin: '10px 0',
    },
  },
  labelContainer: {
    padding: '0!important',
    color  : 'inherit',
  },
  label: {
    textTransform: 'uppercase',
    fontFamily   : 'Montserrat',
    fontSize     : '14px',
    fontWeight   : '500',
    lineHeight   : 1.14,
    letterSpacing: '1.3px',
    position     : 'relative',
    display      : 'block',
    color        : 'inherit',
  },
  primary: {
    '&,&:hover': {
      color: primaryColor,
    },
  },
  info: {
    '&,&:hover': {
      borderBottom: `2px solid ${infoColor}`,
      color       : infoColor,
    },
  },
  success: {
    '&,&:hover': {
      color: successColor,
    },
  },
  warning: {
    '&,&:hover': {
      color: warningColor,
    },
  },
  danger: {
    '&,&:hover': {
      color: dangerColor,
    },
  },
  rose: {
    '&,&:hover': {
      color: roseColor,
    },
  },
  alignCenter: {
    alignItems    : 'center',
    justifyContent: 'center',
  },
});

export default navPillsStyle;
